<template>
  <div v-if="finishedLoading" class="root">
    <div class="packing-list-details container">
      <Navigation />
      <section>
        <div class="row push-down-20">
          <div class="col-12 grid no-padding">
            <div class="row">
              <div class="col-12 col-sm-6 no-padding head">
                <EditableInput class="editable-input-name" v-model="name" @save="updatedName"
                  placeholder="Add a name..." :textarea="false" />
              </div>
            </div>
          </div>
          <div class="col-12 grid no-padding">
            <div class="row">
              <div class="col-12 col-sm-6 no-padding head">
                <EditableInput class="editable-input-description" v-model="description" @save="updatedDescription"
                  placeholder="Add a description..." :textarea="false" />
              </div>
            </div>
          </div>
          <div class="col-12 packing-list-wrapper">
            <PackingList :items="items" :fullWidth="true" :showTitle="false" :showTitlePackingList="true"
              :showSelect="false" @add="addItem" @delete="deleteItem" @update="updateItem" />
          </div>
          <div class="col-12 packing-list-wrapper">
            <RuxDetailsImages :currentRuxImages="images" :fullWidth="true" :showTitle="false" @addImage="addImage"
              @deleteImage="deleteImage" />
          </div>
          <div class="col-12 packing-list-wrapper">
            <div class="col-12 grid">
              <div class="row">
                <div class="col-10 share-packing-list">
                  SHARE PACKING LIST
                </div>
                <div class="col-2 align-center">
                  <input v-model="isPublic" class="pointer sharebox" type="checkbox" />
                </div>
              </div>
              <div v-if="isPublic" class="row">
                <div>
                  <div @click="copy">
                    <div class="share">
                      <button class="button pointer">
                        <span v-if="!showCopied">Touch to Copy</span>
                        <span v-else>Copied!</span>
                        <span @click="copy" v-if="!showCopied" class="material-symbols-outlined">content_copy</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import PackingList from './../PackingList'
import RuxDetailsImages from './../RuxDetailsImages'
import EditableInput from './../EditableInput'
import Navigation from './Nav'

export default {
  name: 'PackingListTemplateItem',
  components: {
    PackingList,
    RuxDetailsImages,
    EditableInput,
    Navigation,
  },
  data: function () {
    return {
      showCopied: false,
      finishedLoading: false,
      showRestOfForm: true,
    }
  },

  methods: {
    addItem(item) {
      this.$store.dispatch('packingListTemplate/addPackingListItemToTemplate', {
        item,
      })
    },
    deleteItem(params) {
      this.$store.dispatch(
        'packingListTemplate/deletePackingListItemFromTemplate',
        params
      )
    },
    updateItem(params) {
      const { index, value } = params
      this.items[index].checked = value
    },
    updatedDescription(description) {
      this.$store.dispatch('packingListTemplate/update', {
        description,
      })
    },
    updatedName(name) {
      this.$store.dispatch('packingListTemplate/update', {
        name,
      })
    },
    updatePublicRUX() {
      this.$store.dispatch('packingListTemplate/update', {
        publicRUX: !this.publicRUX,
      })
    },
    async addImage(params) {
      const { imageData, callback } = params
      await this.$store.dispatch('packingListTemplate/addImage', imageData)
      if (callback) callback()
    },
    deleteImage(params) {
      this.$store.dispatch('packingListTemplate/deleteImage', params)
    },
    editMode(val) {
      this.showRestOfForm = !val
    },
    copy() {
      this.showCopied = true
      const el = document.createElement('textarea')
      el.value = this.getShareLink
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      setTimeout(() => {
        this.showCopied = false
      }, 1500)
    },
  },
  async mounted() {
    // get the template from the list
    await this.$store.dispatch(
      'packingListTemplate/getPackingListTemplateItem',
      {
        name: this.$route.params.name,
      }
    )
    // get the template from the list
    await this.$store.dispatch('packingListTemplate/getImages')
    this.finishedLoading = true
  },
  computed: {
    getShareLink: function () {
      return this.$store.state.packingListTemplate.current.shareableLink
    },
    items: function () {
      return this.$store.state.packingListTemplate.current.packingListItems
    },
    images: function () {
      return this.$store.state.packingListTemplate.current.images
    },
    name: function () {
      return this.$store.state.packingListTemplate.current.name
    },
    description: function () {
      return this.$store.state.packingListTemplate.current.description
    },
    isPublic: {
      get: function () {
        return this.$store.state.packingListTemplate.current.isPublic
      },
      set: function (isPublic) {
        this.$store.dispatch('packingListTemplate/update', {
          isPublic,
        })
      },
    },
  },
}
</script>

<style lang='scss' scoped>
hr {
  margin-top: 4rem;
}
.packing-list-details {
  padding: 0px 30px;
  margin: 0 auto;
  div.row {
    align-items: center;
    justify-content: center;
    div.grid {
      padding: 4px;
      text-align: left;
      @include respond-to('sm') {
        text-align: left;
        padding: 16px 0px;
        margin: 0px;
        border: none;
      }
      .no-padding {
        padding-left: 0px;
        padding-right: 0px;
        @include respond-to('sm') {
          padding-left: 15px;
          padding-right: 15px;
        }
      }
      .short-header {
        font-size: 2rem;
        font-weight: 200;
        overflow: hidden;
        font-family: "Neue Roman";
        white-space: nowrap;
      }
      .head {
        font-weight: bold;
        padding-bottom: 8px;
        @include respond-to('sm') {
          font-weight: normal;
          padding-bottom: 0px;
        }
      }
      .add-margin-top {
        margin-top: 20px;
        @include respond-to('sm') {
          margin-top: 0px;
        }
      }
    }
  }
}
.share-packing-list {
  font-size: large;
  text-align: left;
}
.header {
  font-weight: bold;
  margin-left: 12px;
}
.packing-list-wrapper {
  width: 90%;
  margin: 20px auto;
  padding: 16px;
  background-color: white;
  border-radius: 0px;
  border: 1px solid black;
  box-shadow: 0 2px 2px rgb(0 0 0 / 11%), 0 1px 1px rgb(0 0 0 / 18%);
  @include respond-to('sm') {
    width: 66%;
    padding: 16px;
    padding: 40px;
  }
}
.no-padding {
  padding-left: 0px;
  padding-right: 0px;
  @include respond-to('sm') {
    padding-left: 15px;
    padding-right: 15px;
  }
}
.break-word {
  overflow-wrap: break-word;
}
button {
  background-color: $ruxGreen;
  height: 40px;
}
.share {
  padding: 20px;
  border-radius: 8px;
  .material-symbols-outlined {
    font-size: 16px;
    top: 1px;
    left: 5px;
    position: relative;
  }
}
.sharebox {
  height: 25px;
  width: 25px;
}
.align-center {
  display: flex;
  align-items: center;
}
.editable-input-name {
  font-size: large;
  font-family: "Neue Medium";
}
.editable-input-description {
  font-size: large;
  font-family: "Neue Roman";
  font-weight: 100;
}
.fade-leave-active {
  transition: 1s;
}
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>